import { Page } from '@/core/architecture'

import { ResaleApplicationCreateConfirmationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleApplicationCreateConfirmation Page
 * Implemented as a practical sample.
 */
export const ResaleApplicationCreateConfirmation: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ResaleApplicationCreateConfirmationTemplate state={state} {...actions} />
  )
}
